<template>
  <div>
    <div class="d-flex align-center mb-2">
      <router-link :to="{name: 'storeRedeemable'}" class="router-link">
        <v-icon color="grey darken-1" class="mr-3" size="32">mdi-arrow-left-circle</v-icon>
      </router-link>
      <h3 class="mb-0">Create Redeemable</h3>
    </div>
    <NFTCreate>
      <template v-slot:top>
        <v-row>
          <v-col cols="12">
            <p class="text-14 mb-1">Redeemable Name *</p>
            <v-text-field
                v-model="redeemableForm.name"
                color="indigo"
                outlined
                dense
                :rules="[rules.required]"
            ></v-text-field>
          </v-col>

          <v-col cols="6">
            <p class="text-14 mb-1">Reward Scores *</p>
            <v-text-field
                v-model="redeemableForm.rewardScores"
                color="indigo"
                outlined
                dense
                :rules="[rules.required, rules.positive]"
                type="number"
                placeholder="0"
                @wheel="$event.target.blur()"
            ></v-text-field>
          </v-col>

          <v-col cols="6">
            <p class="text-14 mb-1">Initial Supply *</p>
            <v-text-field
                v-model="redeemableForm.initialSupply"
                color="indigo"
                outlined
                dense
                :rules="[rules.required, rules.positive]"
                type="number"
                placeholder="0  ( No store reserve )"
                @wheel="$event.target.blur()"
            ></v-text-field>
          </v-col>

          <v-col cols="12" sm="6">
            <p class="text-14 mb-1">Copies</p>
            <v-select
                v-model="copySelect"
                color="indigo"
                :items="copySelectItem"
                outlined
                dense
            ></v-select>
          </v-col>

          <v-col cols="12" sm="6">
            <p class="text-14 mb-1">Copies Number</p>
            <v-text-field
                v-model="redeemableForm.copiesNumber"
                color="indigo"
                outlined
                dense
                :rules="[rules.required, rules.positive]"
                type="number"
                :disabled="copySelect==='Unlimited'"
                @wheel="$event.target.blur()"
            ></v-text-field>
          </v-col>
        </v-row>
      </template>
      <template v-slot:createBtn="{metadata, uploadNftMetadata}">
        <v-btn
            block
            dark
            color="indigo darken-3"
            :loading="createRedeemableLoading"
            @click="createHandle(metadata, uploadNftMetadata)"
        >Create</v-btn>
      </template>
    </NFTCreate>

    <!--  success dialog  -->
    <ConfirmationDialog
        :dialogShow="confirmationDialog"
        msg="Success to create new redeemable"
        status="success"
        :confirmationCallback="successCallback"
        btnName="Back"
    ></ConfirmationDialog>
  </div>
</template>

<script>
import NFTCreate from '../Component/NftCreate'
import ethCall from "@/lib/eth/ethCall/index"
import Vue from 'vue'
import config from "@/config";
import ethUtil from "@/lib/eth/util";
import ConfirmationDialog from "@/components/ConfirmationDialog";

export default {
  name: "RedeemableCreate",
  components: {
    ConfirmationDialog,
    NFTCreate
  },
  data() {
    return {
      copySelect: 'Unlimited',
      copySelectItem: ['Unlimited', 'Limited'],
      mintingPeriodStartSelect: 'Now',
      mintingPeriodStartSelectItem: ['Now', 'Specific Time'],
      mintingPeriodExpireSelect: 'Not Expire',
      mintingPeriodExpireSelectItem: ['Not Expire', 'Specific Time'],
      nftGiveAwaySelectItem: ['None', 'Yes'],

      redeemableForm: {
        name: "",
        metadataUrl: "",
        rewardScores: null,
        initialSupply: null,
        copiesNumber: 0,
        mintingPeriodStart: null,
        mintingPeriodExpire: null
      },
      rules: {
        required: value => !!value || 'Required.',
        positive: value => parseInt(value) >= 0 || 'Positive number'
      },
      createRedeemableLoading: false,
      confirmationDialog: false
    }
  },
  methods: {
    async createHandle(metadata, uploadNftMetadata) {
      this.createRedeemableLoading = true
      try {
        const ipfsUrl = await uploadNftMetadata(metadata)
        if (!ipfsUrl) {
          throw Error("Fail to upload nft metadata")
        }
        await ethCall.storeFactory.createRedeemable(
            this.redeemableForm.rewardScores * (10 ** config.commonConfig.paymentCoinDecimal),
            this.redeemableForm.initialSupply,
            this.redeemableForm.copiesNumber,
            ipfsUrl
        )

        this.confirmationDialog = true
      } catch (e) {
        console.log(e)
        const revertMsg = ethUtil.errorMsgHandle(e.message)
        console.log("revert msg: ", revertMsg)
        if (revertMsg) {
          e.message = revertMsg
        }
        console.log("e message: ", e.message)
        Vue.notify({
          type: "error",
          text: e.message
        })
      } finally {
        this.createRedeemableLoading = false
      }
    },
    successCallback() {
      this.$router.push({name: 'storeRedeemable'})
    }
  }
}
</script>

<style scoped>

</style>